<template>
  <div>
    <div v-if="reviewRequired">
      <a class="button btn-primary" :href="reviewPath">
        {{ $t('reviewDesign') }}
      </a>
    </div>
    <div v-else>
      <button
        type="button"
        @click="link"
        :disabled="disableButton"
        class="button primary cell checkout-btn"
      >
        {{ $t('checkout') }}
      </button>
    </div>
  </div>
</template>

<script>
import { components } from 'locales';
import _ from 'lodash';

export default {
  name: 'ProjectCheckoutButton',
  props: {
    checkoutPath: String,
    reviewPath: String,
    orderable: Boolean,
    review: Boolean,
  },
  computed: {
    reviewRequired() {
      const storeData = this.$store?.state?.board;

      return (storeData && storeData?.processed && !storeData?.orderable) || this.review;
    },
    disableButton() {
      if (this.$store && !_.isEmpty(this.$store.state.board)) {
        return !this.$store.state.board.orderable;
      }

      return !this.orderable;
    },
  },
  methods: {
    link() {
      const link = this.disableButton ? '#' : this.checkoutPath;
      window.location.href = link;
    },
  },
  i18n: components.project.ProjectCheckoutButton,
};
</script>

<style lang="scss" scoped>
.checkout-btn {
  font-weight: 700;
}
</style>
